export default {
  'auth.signupMessage': 'Create an Account',
};
